// Unused for now.
// - locale number formatting (for spanish) was added to the calculator widget around January 2023.
// - locale number formatting was then added to rates (sitewide) but was immediately reverted
// - keeping this here as refence in case it needs to be added back again (if so, lang needs to be passed around to determine locale)
// export enum LocaleCodeEnum {
//     en='en-US',
//     es='es-EC', // comma & period formatting with this locale best matches what the copy team has requested
// }

import {calculateDate} from './dateTime';

/**
 * When precision is provided try to render value as a number
 * @param valueStr original value
 * @param precision number of decimal digits to show
 * @returns string
 */
export type FormatType = '#' | '%' | '$' | 'date' | 'timeAgo';
export enum RateType {
    apy='apy',
    apr='apr',
    initialRate='initialRate',
}
interface DataTestRateObj {
    id: number;
    precision?: number;
    resource: string;
    rateType: RateType;
}
interface IFormatValueProps {
    dataTestRateObj?: DataTestRateObj; // used to wrap value in span with data-test-id for automation. (only if provided)
    valueStr: string;
    precision: number | null;
    formatType?: FormatType; // defaults to # for standard number display
}
export function formatValue({ dataTestRateObj, valueStr, precision, formatType = '#' }: IFormatValueProps) {        
    // is this a date?
    if (formatType === 'date' || formatType === 'timeAgo') {
        return calculateDate(valueStr, formatType, "MMMM d, yyyy"); 
    } else {
        // try turning it into a number
        let value = Number(valueStr);

        if (isNaN(value) || !precision) {
            return dataTestRateObj ?
                `<span data-test-id='rate' data-test-rate-id='${dataTestRateObj.id}' data-test-rate-resource='${dataTestRateObj.resource}' data-test-rate-type='${dataTestRateObj.rateType}'>${valueStr}</span>`
                :
                valueStr;
        } else {
            const styleMap = {
                '%': 'percent',
                '$': 'currency',
                '#': 'decimal'
            };
        
            const formatStyle = styleMap[formatType];
            
            // is this a percent?
            if (formatStyle === 'percent') {
                // rates from rateshost are in 'percentage form', not 'decimal form' (ie: (%)5.46 instead of .0546) so divide by 100 to convert to 'decimal form' for toLocaleString() below
                value = value / 100;
            }

            // For future: if locale number formatting needs to be added again, 'en-US' needs to be dynamic (es-EC works good for spanish)
            let returnValue = Number(value).toLocaleString('en-US', { style: formatStyle, currency: formatStyle === 'currency' ? 'USD' : undefined, maximumFractionDigits: precision, minimumFractionDigits: precision });

            return dataTestRateObj ?
                `<span data-test-id='rate' data-test-rate-id='${dataTestRateObj.id}' data-test-rate-resource='${dataTestRateObj.resource}' data-test-rate-type='${dataTestRateObj.rateType}' data-test-rate-precision='${dataTestRateObj.precision}'>${returnValue}</span>`
                :
                returnValue;
        }
    }
}
